<template>
  <app-page-container title="بیمارستان ها">
    <template v-slot:header>
      <v-col cols="4" class="mr-n11">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3"></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main">
        <v-col cols="12">
          <v-card elevation="0" class="body-card card-width pa-0 ma-0">
            <v-card-text class="pa-0 ma-0">
              <v-row>
                <v-col cols="12" class="pa-0">
                  <template>
                    <v-data-table fixed-header :headers="hospital800InformationTableHeaders" :items="hospital800List"
                      :search="searchTitle" :items-per-page="hospital800List.length" height="78vh"
                      :hide-default-footer="true" @contextmenu:row="rightClickHandler" multi-sort
                      class="elevation-0 tt">
                      <template v-slot:no-data>
                        <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                      </template>
                    </v-data-table>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <section>
        <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
          :snakIcon="snakIcon"></alert-component>
        <v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute
          :close-on-content-click="closeOnContentClick" offset-y>
          <v-list dense>
            <v-list-item-group>
              <v-list-item v-for="(item, index10) in rightClickItems" :key="'qq' + index10" dense>
                <v-list-item-icon>
                  <v-icon color="darkColor">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس با بیمارستان'">
                  <v-list-group>
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <v-list-item v-for="(sitem, index) in hospitalPhoneNumbers" :key="'c' + index"
                      @click="rightClickAction(item.title, sitem)">
                      <v-list-item-content>
                        <v-list-item-title class="mr-3">{{ sitem }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </section>
    </template>
  </app-page-container>
</template>
<script>
import AlertComponent from '@/components/AlertComponent.vue';
import AppPageContainer from '@/components/app/PageContainer.vue';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import hospitalMixin from '@/Mixins/BaseInformation/HospitalMixin';
import HospitalListFor800 from '@/Helpers/800/HospitalListFor800Helper.js';
import CallMixin from '@/Mixins/Call/CallMixin';
import UserNotificationMixin from '@/Mixins/800/userNotification.mixin';

export default {
  name: 'HospitalListFor800',
  title: 'بیمارستان ها',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    AlertComponent,
    AppPageContainer,
  },
  mixins: [
    ShearedMixin,
    hospitalMixin,
    HospitalListFor800,
    snackBar,
    ShearedHelper,
    CallMixin,
    UserNotificationMixin,
  ],
  created() {
    this.$root.$refs.HospitalListFor800 = this;
    this.$mainSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
    this.$mobileSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
  },
  beforeDestroy() {
    this.$mainSignalr.bus.$off('DispatchNotification', this.fNotifyOutOfService);
    this.$mobileSignalr.bus.$off('DispatchNotification', this.fNotifyOutOfService);

    delete this.$root.$refs.HospitalListFor800;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      this.getListOfHospitalsForAdMissionFunction();
    },
    fNotifyOutOfService: function (data) {
      switch (data?.type) {
        case 1:
          this.showTostMessage2(data?.text, 'ambulance107s', {
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
          });
          break;
        case 2:
          this.showTostMessage2(data?.text, '', {
            timeout: false,
            closeOnClick: false,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
          });
          break;
        default:
          break;
      }
      this.onGetAllUserNotificationOnSignal();
    },
  },
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber {
  border: 2px solid #cdcbcf !important;
}

.card-add-phoneNumber-items {
  margin-top: -7px !important;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}

.inside-cards {
  border: 1px solid var(--dark-color) !important;
  overflow-y: auto !important;
}

.dialog-part-divider-text {
  color: #212121;
  font-size: 14px;
  font-weight: 600;
}

.chip-text {
  color: var(--dark-color) !important;
}

>>>.tt tbody tr:nth-of-type(even) {
  background-color: var(--background-color) !important;
}
</style>
